<template>
   <div
      class="flex w-fit items-center justify-between gap-1"
      :class="{ 'opacity-80': disabled }"
      @click="() => (disabled ? null : (model = !model))"
   >
      <button
         role="switch"
         type="button"
         class="relative inline-flex h-7 w-[50px] flex-shrink-0 items-center rounded-full p-1 transition-colors"
         :class="{ 'bg-primary': model, 'bg-light-blue': !model, __clickable: !disabled }"
         :aria-checked="model"
      >
         <Badge v-if="badge" />
         <span
            class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform"
            :class="model ? 'translate-x-[22px]' : 'translate-x-0'"
         />
      </button>
      <Label :class="{ __clickable: !disabled }" :disabled="disabled" :extra="extra" :badge="badge">
         {{ label }}
      </Label>
   </div>
</template>

<script lang="ts" setup>
import { defineModel } from 'vue'

type Props = {
   label?: string
   disabled?: boolean
   badge?: boolean
   extra?: string
}

const props = withDefaults(defineProps<Props>(), {})
const model = defineModel<boolean>()
</script>
